import type { ConsumerSpecializationPageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerSpecializationPageQuery';
import { shouldShowGoogleRefresh } from 'bundles/unified-description-page-common/utils/shouldShowGoogleRefresh';

import _t from 'i18n!nls/xdp';

const getBadgeStringsFromS12nPageData = (pageData: ConsumerSpecializationPageFieldsFragment): string[] => {
  const badges: string[] = [];

  const hasTopInstructor = pageData.instructors?.some((instructor) => instructor.isTopInstructor);
  if (hasTopInstructor) {
    badges.push(_t('Top Instructor'));
  }

  const hasNewAISkills = shouldShowGoogleRefresh(pageData.slug);
  if (hasNewAISkills) {
    badges.push(_t('New AI skills'));
  }

  return badges;
};

export default getBadgeStringsFromS12nPageData;
